module.exports = __webpack_public_path__ + "static/media/managejobB.0cba7112.svg";